import React, { useState, useEffect } from 'react'
import { Flex, Button, Input, Avatar, Drawer } from 'antd'
import './delivery.css'
import { postCadastro, postLogin } from '../../services/bd/cardapioDigital'
import { useToasts } from 'react-toast-notifications'
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { deliveryUserState } from '../../store/recoilData'
import { useRecoilState } from 'recoil'
import FECHADURA from '../../img/buraco-da-fechadura.png'
import { LeftOutlined } from '@ant-design/icons'
import TelefoneBrasileiroInput from "react-telefone-brasileiro";
import { validateEmail, validaCelular } from '../../services/util'

export const LoginCtrl = (props) => {

    const [app] = useOutletContext();
    const [user, setUser] = useRecoilState(deliveryUserState)
    const navigate = useNavigate()
    const { nome } = useParams()
    const { addToast } = useToasts()
    const [loading, setLoading] = useState(false)
    const [senha, setSenha] = useState('')
    const [email, setEmail] = useState('')
    const [registro, setRegistro] = useState({
        nome: '',
        senha: '',
        phone: '',
        email: '',
        senha2: ''
    })

    const [openCadastro, setOpenCadastro] = useState(false)
    useEffect(() => {

    }, [])

    return <Flex vertical gap={0} style={{ paddingLeft: 15, paddingRight: 15 }}>
        <Flex justify='center' style={{ marginTop: 20 }}>
            <Avatar shape='square' size={50} src={FECHADURA} />
        </Flex>
        <Flex justify='center' style={{ fontWeight: 600, fontSize: '1.2em', marginTop: 15 }}>Entre com sua conta</Flex>

        <Flex style={{ marginTop: 50 }}>E-mail</Flex>
        <Flex><Input value={email} onChange={(e) => setEmail(e.target.value)} /></Flex>

        <Flex style={{ marginTop: 5 }}>Senha</Flex>
        <Flex><Input.Password value={senha} onChange={(e) => setSenha(e.target.value)} /></Flex>

        <Flex justify='flex-end'> <Button type='text' style={{ color: app.cor }}>Esqueci a senha</Button></Flex>

        <Flex vertical gap={20} align='center' justify='center'>
            <Button
                disabled={validateEmail(!email.trim()) || senha.trim() === ''}
                block
                type='primary'
                style={{ backgroundColor: app?.cor, marginTop: 20 }}
                loading={loading}
                onClick={async () => {
                    try {
                        setLoading(true)
                        const resp = await postLogin({
                            email: email,
                            senha: senha
                        }, {
                            nome: nome
                        })
                        setUser(resp)
                    } catch (error) {
                        addToast(error.message, { autoDismiss: true, appearance: 'error' })
                    }
                    setLoading(false)
                }}>Entrar</Button>

            <Flex><span>Não possui conta? <span style={{ color: app.cor, fontWeight: 600 }}
                onClick={() => {
                    setOpenCadastro(true)
                }}>Cadastre-se</span></span></Flex>
        </Flex>


        <Drawer
            width={"100%"}
            onClose={() => setOpenCadastro(false)}
            open={openCadastro}
            title={<Flex justify='center'> CADASTRO </Flex>}
            closable={true}
            closeIcon={<LeftOutlined />}>
            <Flex vertical style={{ paddingLeft: 10, paddingRight: 10 }}>
                <Flex style={{ fontWeight: 600, fontSize: '1.2em', marginTop: 15 }} justify='center'>Crie sua conta</Flex>

                <Flex style={{ marginTop: 20 }}>Nome</Flex>
                <Input maxLength={150} value={registro.nome} onChange={(e) => setRegistro({ ...registro, nome: e.target.value })} />

                <Flex style={{ marginTop: 5 }}>Celular</Flex>
                <TelefoneBrasileiroInput
                    autocomplete="off"
                    autoComplete="off"
                    className={"ant-input css-dev-only-do-not-override-aya5jp ant-input-outlined"}
                    style={{
                        paddingLeft: 6, paddingTop: 6, paddingBottom: 6, autocomplete: "off", borderRadius: 5, borderWidth: 0.3,
                        BorderColor: 'ligthgray'
                    }}
                    value={registro.phone}
                    onChange={(e) => {
                        setRegistro({ ...registro, phone: e.target.value })
                    }}
                    temDDD
                    separaNono={true}
                    separaDDD={true}
                />


                <Flex style={{ marginTop: 5 }}>E-mail</Flex>
                <Input maxLength={150} value={registro.email} onChange={(e) => setRegistro({ ...registro, email: e.target.value })} />

                <Flex style={{ marginTop: 5 }}>Senha</Flex>
                <Input.Password maxLength={20} value={registro.senha} onChange={(e) => setRegistro({ ...registro, senha: e.target.value })} />

                <Flex style={{ marginTop: 5 }}>Confirme a Senha</Flex>
                <Input.Password maxLength={20} value={registro.senha2} onChange={(e) => setRegistro({ ...registro, senha2: e.target.value })} />

                {registro.senha !== registro.senha2 && <Flex style={{ color: 'red', fontSize: '0.7em' }}>As senhas não são iguais</Flex>}

                <Button
                    block
                    disabled={!validateEmail(registro.email) || registro.nome.trim() === "" || registro.senha.trim() === "" || (registro.senha !== registro.senha2)
                        || !validaCelular(registro.phone)
                    }
                    type='primary'
                    style={{ backgroundColor: app.cor, marginTop: 30 }} onClick={async () => {
                        try {
                            setLoading(true)
                            console.log(registro)
                            const resp = await postCadastro(registro, { nome: nome })
                            setUser(resp)
                        } catch (error) {
                            addToast(error.message, { appearance: 'error', autoDismiss: true })
                        }
                        setLoading(false)
                    }}> Salvar</Button>

            </Flex>

        </Drawer>

    </Flex>


}



export default LoginCtrl